import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Row, Col } from 'react-bootstrap';
import { debounce } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

import SidebarSearch from 'components/search_sidebar/sidebar_search';
import {
  clearListings,
  searchListings,
  setSearchText,
  handleSort
} from './actions';
import PinnedListingRow from './pinned_listing_row';
import ListingRow from './listing_row';

import './index.scss';

export class Selector extends Component {
  componentDidMount() {
    this.debouncedhandleSearch();
  }

  filteredSearchResults = () => {
    const { searchResults, pinnedListings } = this.props;
    return searchResults.filter(listing => !pinnedListings.find(l => l.propertyPluginListingId == listing.id));
  }

  handleSearchTextChange = (e) => {
    this.props.setSearchText(e.target.value);
    this.debouncedhandleSearch();
  }

  debouncedhandleSearch = debounce(this.handleSearch, 250);

  handleSearch() {
    const { searchText } = this.props;
    this.props.searchListings({ searchText });
  }

  renderPinnedListing = (listing, idx) => {
    return (
      <PinnedListingRow
        index={idx}
        key={listing.id}
        listing={listing}
        name="pinned-listing-row"
      />
    );
  }

  renderSearchResult = (listing) => {
    return <ListingRow key={listing.id} listing={listing} name="listing-row"/>;
  }

  renderPinnedListings = () => {
    const { pinnedListings } = this.props;
    if (pinnedListings.length > 0) return pinnedListings.map(this.renderPinnedListing);

    return (
      <div className="p-3 border-top" name="pinned-listings-empty">
        No listings pinned yet
      </div>
    );
  }

  renderSearchResults = () => {
    const { searchText, waiting } = this.props;
    if (waiting) return (
      <div className="p-3 border-top">
        <FontAwesomeIcon icon={faSpinner} name="results-loading" spin/>
      </div>
    );

    const filteredSearchResults = this.filteredSearchResults();
    if (filteredSearchResults.length > 0) return filteredSearchResults.map(this.renderSearchResult);

    return (
      <div className="p-3 border-top" name="search-results-empty">
        {searchText.length > 0 ? `No results found for ${searchText}` : 'No Listings'}
      </div>
    );
  }

  render() {
    return (
      <Row>
        <Col xs={6}>
          <label>Available Listings</label>
          <div className="border panel panel-default">
            <div className="panel-heading">
              <SidebarSearch
                name="listing-search"
                placeholder="Search Listings..."
                size="xs"
                value={this.props.searchText}
                onChange={this.handleSearchTextChange}
              />
            </div>
            <div className="listings" name="search-results">
              {this.renderSearchResults()}
            </div>
          </div>
        </Col>
        <Col xs={6}>
          <label>Pinned Listings</label>
          <div className="border panel panel-default">
            <div className="sort-toolbar panel-heading">
              Sort by:
              <a className="mx-2 clickable" name="city" onClick={this.props.handleSort}>City</a>
              <a className="mx-2 clickable" name="address" onClick={this.props.handleSort}>Address</a>
              <a className="mx-2 clickable" name="broker" onClick={this.props.handleSort}>Broker</a>
              <a className="mx-2 clickable" name="reverse" onClick={this.props.handleSort}>Reverse</a>
              <a className="clickable text-right flex-grow" name="clear" onClick={this.props.clearListings}>
                Clear
              </a>
            </div>
            <div className="listings" name="pinned-listings">
              {this.renderPinnedListings()}
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

Selector.propTypes = {
  clearListings: PropTypes.func.isRequired,
  handleSort: PropTypes.func.isRequired,
  pinnedListings: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired
  })).isRequired,
  searchListings: PropTypes.func.isRequired,
  searchResults: PropTypes.arrayOf(PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired
  })).isRequired,
  searchText: PropTypes.string,
  setSearchText: PropTypes.func.isRequired,
  waiting: PropTypes.bool
};

const mapStateToProps = ({ pinnedListings, searchResults, module }) => ({
  pinnedListings,
  searchResults,
  searchText: module.searchText,
  waiting: module.waiting
});
const mapDispatchToProps = {
  clearListings,
  searchListings,
  setSearchText,
  handleSort
};

export default connect(mapStateToProps, mapDispatchToProps)(reorderableList(Selector));
